import { createSlice } from "@reduxjs/toolkit";

const errorSlice = createSlice({
  name: "error",
  initialState: {
    logout : false ,
    sessionEnd : false,
    disabledAccount:false
  },
  reducers: {
    setLogout: (state, { payload }) => {
      state.logout = payload;
    },
    setSessionEnd: (state, { payload }) => {
      state.sessionEnd = payload;
    },
    setDisabledAccount: (state, { payload }) => {
      state.disabledAccount = payload;
    },
  },
});
export const { setLogout ,setSessionEnd , setDisabledAccount } = errorSlice.actions;
export default errorSlice.reducer;
